const DateService = {
    getTodayLocalDateString: () => {
        const d = new Date();
        return (
            d.getFullYear() +
            "-" +
            String(d.getMonth() + 1).padStart(2, "0") +
            "-" +
            String(d.getDate()).padStart(2, "0")
        );
    },
    dateTimeToDate : (dateTime) => {
        return dateTime.substring(0, 10);
    },
    getDate : (dateValue) => {
        if (dateValue instanceof Date) {
            return dateValue;
        }

        if (typeof dateValue === 'string') {
            // Try parsing ISO string (e.g., "2025-08-24T21:51:00+03:00")
            const parsedDate = new Date(dateValue);
            if (!isNaN(parsedDate.getTime())) {
                return parsedDate;
            }

            // Try parsing date-only string (e.g., "2025-08-24")
            const dateOnly = new Date(dateValue + 'T00:00:00');
            if (!isNaN(dateOnly.getTime())) {
                return dateOnly;
            }
        }

        // Return current date as fallback or throw error
        console.warn('Invalid date value, using current date as fallback');
        return new Date();
    }
}

export default DateService